import { DialogActions, styled } from '@mui/material';

export const Footer = styled(DialogActions)`
  padding: 16px;
  gap: 16px;
`;
